<div class="container">
  <ngx-doc-viewer
    [url]="blobUrl!"
    style="max-width: 100%; height: 70vh"
    viewer="url"
  ></ngx-doc-viewer>
</div>
